<template>
  <textarea :name="_name"
            v-model="value"
            :placeholder="spec.placeholder"
            :readonly="_readonly"
            class="form-control"></textarea>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-textarea',
    mixins: [mixin],
  };
</script>



// WEBPACK FOOTER //
// f-textarea.vue?0eb3b876